export const formatWeight = (str?: string) => {
  if (!str) return '';

  return str.replace(/ /g, '_');
};
